import { ActionsUnion, IActionWithPayload, createAction } from "store/helper";

export const InstructionsModalViewActionsNames = {
  SEND_FORWARDING_INSTRUCTIONS: "VIEWS/INSTRUCTIONS_MODAL/SEND_FORWARDING_INSTRUCTIONS",
};

export const InstructionsModalViewActions = {
  sendForwardingInstructions: (
    recipientEmail: string
  ): IActionWithPayload<
    string,
    {
      recipientEmail: string;
    }
  > => createAction(InstructionsModalViewActionsNames.SEND_FORWARDING_INSTRUCTIONS, { recipientEmail }),
};

export type ForwardingInstructionsViewAction = ActionsUnion<typeof InstructionsModalViewActions>;
